import React from 'react';

const ActionListDivider = (props) => {
  return <div className="ws-ui-action-list-divider" {...props} />;
};

export default ActionListDivider;
